module.exports = __webpack_public_path__ + "static/6-73acf320e528d55fac5e3e50fc865e73.png";